import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { UsersTable } from "components/UsersTable/UsersTable";
import { Button } from "components/shared";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { AddingUser } from "pages/References/UsersPage/AddingUser/AddingUser";
import { Link, Search } from "components-new";
import { ReactComponent as ActionIconSvg } from "images/ActionMenuIcon.svg";
import { ReactComponent as ArchiveIconSvg } from "images/archive.svg";
import useDebounce from "hooks/useDebounce";
import DropSelect from "components-new/DropSelect";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import StepInfo from "pages/StepPages/components";
import { useLocation } from "react-router-dom";
import styles from "pages/References/UsersPage/UsersPage.module.sass";
import sass from "pages/References/AreasOfActivity/areasActivity.module.sass";
import {userAPI} from "libs/apiClient/User";

export const UsersPage: FC = () => {
	const [modalWindow, setModalWindow] = useState<boolean>(false);

	const location = useLocation();
	const state = location.state;

	const actionsRef = useRef(null);
	const [actionsVisible, setActionsVisible] = useState<boolean>(false);

	const [searchValue, setSearchValue] = useState<string>("");
	const debouncedSearchValue = useDebounce(searchValue, 400);

	const archive = useMemo(() => {
		return /\/archive$/.test(location.pathname);
	}, [location.pathname]);

	const select = useMemo(() => {
		return /\/select$/.test(location.pathname);
	}, [location.pathname]);

	useOutsideAlerter(actionsRef.current, () => setActionsVisible(false));

	useEffect(() => {
		if (state?.from === "user") {
			setModalWindow(true);
		}
		//eslint-disable-next-line
	}, []);

	const openModalWindow = () => {
		setModalWindow(true);
	};

	const closeModalWindow = () => {
		setModalWindow(false);
	};
	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);

	const [create, setCreate] = useState(false);

	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["system.user.create"]).then(({ data }) => {
			setCreate(!!data.length);
		});
	}, []);

	return (
		<main className="step-wrapper">
			{modalWindow && (
				<ModalWindow close={closeModalWindow} transparent={false}>
					<AddingUser close={closeModalWindow} />
				</ModalWindow>
			)}
			<section className={styles.users}>
				<div className="step-header">
					<StepInfo
						info={
							archive
								? "Архив справочника пользователей"
								: select
								? "Выберите пользователя"
								: "Справочник пользователей"
						}
					/>

					<div className="step-header__actions">
						<Search
							handleSearch={(e) => setSearchValue(e.target.value)}
							searchValue={searchValue}
							placeholder={"Найти пользователя..."}
							className={styles.search}
						/>
						{!archive && (
							<>
								<Button disabled={!create} onClick={openModalWindow} className={styles.button}>
									Добавить пользователя
								</Button>

								<ActionIconSvg
									className={styles.actionsIcon}
									ref={actionsRef}
									onClick={() => setActionsVisible(!actionsVisible)}
								/>
							</>
						)}

						{actionsVisible && (
							<DropSelect target={actionsRef.current} position="right">
								<div className="staff-dropDown">
									{/*<button className="staff-table-action-menu-btn">*/}
									{/*  <ImportIconSvg className="staff-table-importIcon" />*/}
									{/*  Импорт*/}
									{/*</button>*/}
									<Link to="archive" state={location.state}>
										<button className="staff-table-action-menu-btn">
											<ArchiveIconSvg className="staff-table-archiveIcon" />
											Архив
										</button>
									</Link>
								</div>
							</DropSelect>
						)}
					</div>
				</div>
				<UsersTable outline={outlineStyle} query={debouncedSearchValue} org={null} archive={archive} select={select} />
			</section>
		</main>
	);
};
